export default "__VITE_ASSET__DEyw26vV__"